import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";

export default {
    component: loadingComponent,
    renderSeo: ({ dispatch }, allMessage, lang, path) => {
        SeoRenderer({ title: allMessage["help.title"], allMessage, lang });
    },
};
